



import ProjectPage from '../projectManagement/project.vue'
export default {
  name: 'projectRD',
  components: { ProjectPage },
}
